import { Link } from 'react-router-dom'

import { Paths } from '../../config/routes'

export function NotFound() {
    return (
        <div className='w-full text-center'>
            <p>Page not found</p>
            <Link to={Paths.DASHBOARD}>Return to dashboard</Link>
        </div>
    )
}
